/*
 * Copyright (c) 2021 LucidResolutions LLC. All rights reserved.
 */



import React, {useEffect, useState} from "react";
import {Badge, Button, Card, Col, Form, Input, message, notification, Result, Row, Space} from 'antd';
import {LockOutlined, UserOutlined} from "@ant-design/icons";
import {IfTruthy} from "../../component/if.equal.component";
import UserService from "../../service/user.service";
import {useHistory} from "react-router-dom";

let userSVC = new UserService()

export const ResetPasswordPage = (props: any)=>{
    let history = useHistory()
    const [email, setEmail] = useState('')
    const [token, setToken] = useState('')
    const [password, setPassword] = useState('')
    const [expired, setExpired] = useState(true)
    useEffect(()=>{
        try{
            let search = props?.history?.location?.search || ''
            let params = new URLSearchParams(search)
            let raw = params.get("t") || ''
            let [userEmail, tok, expirationTime] = atob(raw).split('.')
            // @ts-ignore
            if((expirationTime*1000) > (new Date().getTime()) && tok && userEmail) {
                setEmail(atob(userEmail))
                setToken(tok)
                setExpired(false)
            }
        }catch (e){
            setExpired(true)
        }
    })

    const updatePassword = (v: any)=>{
        userSVC.reset(v["p"], token).then(()=>{
            history.replace("/login", {
                email: email,
                password: password,
                login: true,
            })
        }).catch((e)=>{
            if(e?.status == 404){
                setExpired(true)
                return
            }

            notification.error({
                placement: 'topLeft',
                message: "something went wrong"
            })
        })
    }


    return (
        <Row>
            <Col xs={{span: 24}} lg={{span: 12, offset: 6}}>
                <Badge.Ribbon placement={'start'} text="Reset Password">
                    <Card style={{paddingTop:40}} >
                        <IfTruthy val={expired}>
                            <Result
                                title="Your token is expired"
                            />
                        </IfTruthy>
                        <IfTruthy val={!expired}>
                            <Form
                                size={'large'}
                                name="forgot"
                                className="forgot-form"
                                onFinish={updatePassword}
                            >
                                <Form.Item
                                    name="p"
                                    rules={[{ required: true, message: 'Password required' }]}
                                >
                                    <Input.Password prefix={<LockOutlined className="site-form-item-icon" />}
                                           placeholder="New Password"
                                           onChange={(v)=>setPassword(v.target.value)}
                                    />
                                </Form.Item>

                                <Form.Item>
                                    <Space>
                                        <Button type="primary"  htmlType="submit" className="login-form-button">
                                            Reset
                                        </Button>
                                    </Space>
                                </Form.Item>
                            </Form>
                        </IfTruthy>

                    </Card>
                </Badge.Ribbon>
            </Col>
        </Row>
    )
}
